import * as React from 'react';
import EventStepper from '../../../../../components/EventStepper';
import { fm } from 'Components/FormatMessage';
import InputHandler from '../../../../../components/InputHandler';
import { StepperHeaderFormInputPair, StepperHeaderValuePair } from 'Components/EventStepper/components';
import { formatPartialDate } from 'Utility/date';

const Complications = ({ formData }: IOwnProps): React.JSX.Element => {
  return (
    <EventStepper
      name="complications"
      formData={formData}
      stepLabelText={(d: ITDCSComplication): string => formatPartialDate(d.date)}
      stepContent={(d: ITDCSComplication): React.JSX.Element => (
        <React.Fragment>
          {['complications', 'additionalInformation'].map((key, index) => {
            const value = d[key as keyof ITDCSComplication];
            return (
              <StepperHeaderValuePair
                key={`${key}${index}`}
                header={fm(`tdcs.${key}`)}
                value={
                  value && (Array.isArray(value) ? value.length > 0 : true)
                    ? key === 'complications' && Array.isArray(value)
                      ? value.map(v => <div key={v}>{fm(`tdcs.opts.complications.${v}`)}</div>)
                      : value
                    : '-'
                }
              />
            );
          })}
        </React.Fragment>
      )}
      addNewTextHeader="tdcs.complications"
      addNewTextButton="tdcs.newComplication"
      previousEventsTextHeader="tdcs.previousComplications"
      editingElements={(index: number, onChange: IFormData['onChange']): React.JSX.Element => (
        <React.Fragment>
          <StepperHeaderFormInputPair
            header={fm('general.date')}
            input={
              <InputHandler
                type="PartialDate"
                editing={true}
                name="date"
                formData={{
                  onChange,
                  document: { date: formData.document.complications?.[index]?.date ?? '' },
                }}
                dateDefault="now"
                isNotCancellable={true}
                dateHook={{ dateHookFloor: formData.document.date ?? undefined }}
              />
            }
          />
          <StepperHeaderFormInputPair
            header={fm('tdcs.complications')}
            input={
              <InputHandler
                type="Checkbox"
                editing={true}
                name="complications"
                formData={{
                  onChange,
                  document: { complications: formData.document.complications?.[index]?.complications ?? '' },
                }}
                options={[
                  'headache',
                  'bloodPressureReaction',
                  'dysrhythmia',
                  'allergicReation',
                  'aspirate',
                  'epilepticSpasm',
                ]}
                optionFormatter={(name: string | number): React.JSX.Element => fm(`tdcs.opts.complications.${name}`)}
              />
            }
          />
          <StepperHeaderFormInputPair
            header={fm('tdcs.additionalInformation')}
            input={
              <InputHandler
                type="TextArea"
                editing={true}
                name="additionalInformation"
                formData={{
                  onChange,
                  document: {
                    additionalInformation: formData.document.complications?.[index]?.additionalInformation ?? '',
                  },
                }}
                placeholder="tdcs.additionalInformationComplications"
              />
            }
          />
        </React.Fragment>
      )}
    />
  );
};

interface IOwnProps {
  formData: IFormData<IDocumentWithTypeV2<'tdcs'>>;
}

export default Complications;
